import { userType, userPrivilege } from "const/nuclias/user";

// View
export const defaultPathList = [
  { label: 'f4f70727dc', isLink: false },
  { label: '09f0c5159c', isLink: false },
];

export const defaultMessages = {
  success: null,
  error: null,
  warning: null,
};

export const defaultModalStatus = {
  inviteAndEdit: {
    status: false,
    disabled: false,
  },
  delete: {
    status: false,
    disabled: false,
  },
  resendVerificationEmail: {
    status: false,
    disabled: false,
  }
};

export const defaultTableColumn = {
  sp: [
    { label: '49ee308734', accessor: 'name', sortable: true },
    { label: 'ce8ae9da5b', accessor: 'email', sortable: true },
    { label: 'de88250cdc', accessor: 'accessLevelLabel', sortable: true },
    { label: '727b677950', accessor: 'accessPrivilege', sortable: true },
    { label: '2808d28b05', accessor: 'managedScopeLength', sortable: true },
    { label: 'ec53a8c4f0', accessor: 'status', sortable: true },
    { label: '395a3d4fec', accessor: 'lastAccessTime', sortable: true }
  ],
  org: [
    { label: '49ee308734', accessor: 'name', sortable: true },
    { label: 'ce8ae9da5b', accessor: 'email', sortable: true },
    { label: 'de88250cdc', accessor: 'accessLevelLabel', sortable: true },
    { label: '727b677950', accessor: 'accessPrivilege', sortable: true },
    { label: '6821f4bbf3', accessor: 'managedScopeLength', sortable: true },
    { label: 'ec53a8c4f0', accessor: 'status', sortable: true },
    { label: '395a3d4fec', accessor: 'lastAccessTime', sortable: true }
  ],
};

export const defaultSearch = {
  fuzzy: null,
  name: null,
  email: null,
  role: null
};

export const searchType = {
  fuzzy: {
    value: 'fuzzy'
  },
  name: {
    value: 'name',
    label: '49ee308734'
  },
  email: {
    value: 'email',
    label: 'ce8ae9da5b'
  },
  role: {
    value: 'role',
    label: '727b677950'
  }
};

// Model
export const defaultActionMode = { add: 'add', edit: 'edit' };

export const defaultSelectedItem = { id: 0, isAll: true, title: 'b1c94ca2fb', isActive: false, checked: false };
export const defaultSelectedAllSitesItem = { id: 0, title: '299287797e', isActive: false };

export const defaultAccessPrivilege = { type: '', typeLabel: '' };
export const defaultAccessLevel = { type: '', typeLabel: '', owner: '' };
export const defaultManagedList = { siList: [], siteList: [] };
export const defaultLastAccessTime = { datetime: '', timestamp: 0 };

export const defaultAccessRoleList = [
  { id: 0, title: 'e3afed0047', value: userPrivilege.manager, isActive: false },
  { id: 1, title: '344a7f427f', value: userPrivilege.editor, isActive: false },
  { id: 2, title: '6ba872551f', value: userPrivilege.monitor, isActive: false },
  { id: 3, title: 'fb15c53f22', value: userPrivilege.viewer, isActive: false },
];

export const defaultAccessLevelTypeList = [
  { id: 0, title: 'e1b3ec89ea', value: userType.sp, isActive: false },
  { id: 1, title: '4b65444060', value: userType.si, isActive: false },
  { id: 2, title: 'c1ca926603', value: userType.org, isActive: false },
  { id: 3, title: '3039a00fca', value: userType.siteTag, isActive: false },
  { id: 4, title: 'a7d6475ec8', value: userType.site, isActive: false },
];

export const defaultAccountState = {
  name: {
    value: '',
    dirty: false,
    valid: false
  },
  email: {
    value: '',
    dirty: false,
    valid: false
  },
  accessPrivilegeRole: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  accessPrivilegeLevelType: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  accessPrivilegeLevelOrg: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  managedMSP: {
    list: [],
    disabled: false,
    valid: true
  },
  managedOrganization: {
    value: 'b1c94ca2fb',
    valid: true
  },
  managedSiteTag: {
    list: [],
    selected: {},
    disabled: false,
    valid: true
  },
  managedSite: {
    list: [],
    originList: [],
    selected: {},
    disabled: false,
    valid: true
  },
};